export const BRAND_AFFINITY_MAP = [
  { name: "BMW", name_bq: "A.BMW_AFFINITY" },
  { name: "Cadillac", name_bq: "A.CADILLAC_AFFINITY" },
  { name: "Chevrolet", name_bq: "A.CHEVROLET_AFFINITY" },
  { name: "Chrysler", name_bq: "A.CHRYSLER_AFFINITY" },
  { name: "Coupe", name_bq: "A.COUPE_AFFINITY" },
  { name: "Dodge", name_bq: "A.DODGE_AFFINITY" },
  { name: "Ford", name_bq: "A.FORD_AFFINITY" },
  { name: "GMC", name_bq: "A.GMC_AFFINITY" },
  { name: "Honda", name_bq: "A.HONDA_AFFINITY" },
  { name: "Hybrid", name_bq: "A.HYBRID_AFFINITY" },
  { name: "Hyundai", name_bq: "A.HYUNDAI_AFFINITY" },
  { name: "Infinity", name_bq: "A.INFINITY_AFFINITY" },
  { name: "Jeep", name_bq: "A.JEEP_AFFINITY" },
  { name: "Land Rover", name_bq: "A.LANDROVER_AFFINITY" },
  { name: "Lexus", name_bq: "A.LEXUS_AFFINITY" },
  { name: "Lincoln", name_bq: "A.LINCOLN_AFFINITY" },
  { name: "Mercedes Benz", name_bq: "A.MERCEDES_AFFINITY" },
  { name: "Nissan", name_bq: "A.NISSAN_AFFINITY" },
  { name: "Sedan", name_bq: "A.SEDAN_AFFINITY" },
  { name: "SUV", name_bq: "A.SUV_AFFINITY" },
  { name: "Toyota", name_bq: "A.TOYOTA_AFFINITY" },
  { name: "Truck", name_bq: "A.TRUCK_AFFINITY" },
  { name: "Van", name_bq: "A.VAN_AFFINITY" },
  { name: "Volvo", name_bq: "A.VOLVO_AFFINITY" },
]

const normalizeMake = (make) => make?.trim().toLowerCase() || ""

export const findBrandAffinity = (make) =>
  BRAND_AFFINITY_MAP.find(
    (brand) => normalizeMake(brand.name) === normalizeMake(make)
  )

export const buildBrandLoyaltyForMake = (make) => {
  const match = findBrandAffinity(make)
  return BRAND_AFFINITY_MAP.map((brand, index) => {
    const isMatch = match && brand.name_bq === match.name_bq
    return {
      name: brand.name,
      id: index,
      name_bq: brand.name_bq,
      status: isMatch ? "Most Likely To Purchase" : "Not Applicable",
      code: isMatch ? ["3", "4", "5"] : ["0"],
    }
  })
}

export const buildBrandLoyaltySql = (brandLoyalty) => {
  const active = brandLoyalty.filter((item) => item.status !== "Not Applicable")
  return active
    .map((item) => `${item.name_bq} IN('${item.code.join("','")}')`)
    .join(" AND ")
}
